import { render } from "./MaskModal.vue?vue&type=template&id=9ab2ad1e&scoped=true&ts=true"
import script from "./MaskModal.vue?vue&type=script&lang=ts"
export * from "./MaskModal.vue?vue&type=script&lang=ts"

import "./MaskModal.vue?vue&type=style&index=0&id=9ab2ad1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab2ad1e"]])

export default __exports__